export enum BoardsTitle {
  trd = "Trades",
  ma = "Machine",
  rr = "Railroad",
  n = "Warehouse",
  dk = "Dock",
  ws = "Wheat Specialty",
  wm = "Wheat Machine",
  cw = "Coastwise",
  ckd = "Dock Checkers",
  fa = "First Aid",
  gan = "Gang",
  sq = "Squamish",
  lin = "Lines",
  ts = "Topside",
  hld = "Hold",
  vis = "Visitors",
  sur = "Surplus",
}